import { withInstall } from "../utils/index.mjs";
import _Badge from "./Badge.mjs";
const Badge = withInstall(_Badge);
var stdin_default = Badge;
import { badgeProps } from "./Badge.mjs";
export {
  Badge,
  badgeProps,
  stdin_default as default
};
